import {crmType, pbxType} from '../../../../types/apps/AppsModel'
import {IRoistat} from '../../../../types/apps/crm/roistat'

export type yeastarSeriesType = 'S' | 'P'

export interface ICreateApp {
  crm: crmType
  pbx: pbxType
  region: string
  auto_mode: boolean
  time_zone: string
  ami_host: string
  ami_username: string
  ami_secret: string
  domain: string
  ignore_trunks?: string
  record_url: string
  /*usersInService: boolean*/
  outgoing_call_amo: string
  /*outgoing_call_b24: boolean*/
  line_did_amo_0: string
  line_description_amo_0: string
  line_pipeline_amo_0: string
  manager_id: number
  line_smcall_amo_0: boolean
  line_smtime_start_amo_0: string
  line_smtime_end_amo_0: string
  line_incomingcall_amo_0: string
  line_unsorted_amo_0: boolean
  line_findunsorted_amo_0: boolean
  line_did_b24_0: string
  line_description_b24_0: string
  line_smcall_b24_0: boolean
  line_b24time_b24_0: boolean
  line_b24time_end_b24_0: string
  line_b24time_start_b24_0: string
  line_autolead_b24_0: boolean
  line_chat_b24_0: boolean
  api_is_active: boolean
  mp3_is_active: boolean
  yeastar_host: string
  yeastar_username: string
  yeastar_secret: string
  ftp_path: string
  roistat_id_project: string
  roistat_api_key: string
}

export const inits: ICreateApp = {
  crm: 'BITRIX24',
  pbx: 'ASTERISK',
  region: 'BY',
  auto_mode: false,
  time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC',
  ami_host: '',
  ami_username: '',
  ami_secret: '',
  domain: '',
  ignore_trunks: undefined,
  record_url: '',
  outgoing_call_amo: 'Contact',
  line_did_amo_0: '',
  line_description_amo_0: '',
  line_pipeline_amo_0: '',
  manager_id: 1,
  line_smcall_amo_0: false,
  line_smtime_start_amo_0: '09:00',
  line_smtime_end_amo_0: '18:00',
  line_incomingcall_amo_0: 'Contact',
  line_unsorted_amo_0: false,
  line_findunsorted_amo_0: false,
  line_did_b24_0: '',
  line_description_b24_0: '',
  line_smcall_b24_0: false,
  line_b24time_b24_0: false,
  line_b24time_end_b24_0: '18:00',
  line_b24time_start_b24_0: '09:00',
  line_autolead_b24_0: false,
  line_chat_b24_0: false,
  api_is_active: false,
  mp3_is_active: false,
  yeastar_host: '',
  yeastar_username: '',
  yeastar_secret: '',
  ftp_path: '/ftp_media/mmc/autorecords/',
  roistat_id_project: '',
  roistat_api_key: '',
}

export interface IAppAMISettings {
  host: string
  username: string
  secret: string
}

export interface IAppAsterisk {
  record_url: string
}

export interface IAppYeastar {
  series: string
  api_is_active: boolean
  mp3_is_active: boolean
  host: string
  username: string
  secret: string
  ftp_path: string
}

export interface IAppIncomingCallMode {
  none: boolean
  unsorted: boolean
  contact: boolean
  contact_lead: boolean
}

export interface IAppBitrix24Lines {
  line: string
  description: string
  responsible_user: number
  smart_call: boolean
  b24_manager_time: boolean
  start_time: string
  end_time: string
  auto_lead: boolean
  chat: boolean
}

export interface Bitrix24Credentials {
  id?: string
  client_id: string
  client_secret: string
}

export interface IAppBitrix24 {
  users_in_service: boolean
  mode_is_cloud: boolean
  lines: Array<IAppBitrix24Lines>
  credentials?: Bitrix24Credentials
}

export interface IAppAmoCRMLine {
  id?: string
  line: string
  description: string
  pipeline: string
  responsible_user: number
  incoming_call_mode: IAppIncomingCallMode
  smart_call: boolean
  start_time: string
  end_time: string
}

export interface IAppAmoCRM {
  outgoing_call_mode: IAppIncomingCallMode
  lines: IAppAmoCRMLine[]
}

export interface IAppCreateDataSettings {
  ami?: IAppAMISettings
  asterisk?: IAppAsterisk
  yeastar?: IAppYeastar
  ignore_trunks?: Array<string>
  bitrix24?: IAppBitrix24
  amocrm?: IAppAmoCRM
  roistat?: IRoistat
}

export interface IAppCreateData {
  crm_domain: string
  crm: crmType
  pbx: pbxType
  region: string
  is_auto_mode: boolean
  time_zone: string
  settings: IAppCreateDataSettings
}

export type CreateAppQueryState = {
  crm: crmType
  pbx: pbxType
  sm_call_b24: boolean
  sm_call_amo: boolean
  time_b24: boolean
  time_block: boolean
  api_active: boolean
  error: string
  is_created_successful: boolean
  outgoing_call: string
  tokens_bitrix24: string
  is_valid_amocrm: boolean
  domain: string
  error_tokens_bitrix24: boolean
  yeastar_series: yeastarSeriesType
  mode_is_cloud: boolean
  bitrix24_client_id?: string
  bitrix24_client_secret?: string
}

export const defaultCreateAppState: CreateAppQueryState = {
  crm: 'BITRIX24',
  pbx: 'ASTERISK',
  sm_call_b24: false,
  sm_call_amo: false,
  time_b24: false,
  time_block: true,
  api_active: false,
  error: '',
  is_created_successful: false,
  outgoing_call: 'Contact',
  tokens_bitrix24: '',
  is_valid_amocrm: false,
  domain: '',
  error_tokens_bitrix24: false,
  yeastar_series: 'S',
  mode_is_cloud: true,
  bitrix24_client_id: '',
  bitrix24_client_secret: '',
}

export type QueryRequestContextPropsCreateApp = {
  state: CreateAppQueryState
  updateState: (updates: Partial<CreateAppQueryState>) => void
}

export const initialQueryRequestCreateApp: QueryRequestContextPropsCreateApp = {
  state: defaultCreateAppState,
  updateState: () => {},
}
